<div class="info-container">
  <div class="header">
    <div class="img-container text-center">
      <img src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler" width="200" />
    </div>
  </div>

  <div class="info-content">
    <div class="header">
      <h4>Azgaar's Fantasy Map Generator<br>Website and Tutorials</h4>
    </div>

    <div class="tutorials-section">
      <!-- Website -->
      <div class="tutorial-item">
        <img src="assets/images/azgaar-poster.png" alt="Azgaar's Site Thumbnail" class="video-thumbnail" />
        <div class="tutorial-text">
          <h5>Azgaar's Fantasy Map Generator Site</h5>
          <a href="https://azgaar.github.io/Fantasy-Map-Generator/" target="_blank" class="tutorial-link">
            Open-source Fantasy Map Generator
          </a>
        </div>
      </div>

      <!-- Video 1 -->
      <div class="tutorial-item">
        <img src="https://img.youtube.com/vi/6MFiHXAVUUY/mqdefault.jpg" alt="Video 1 Thumbnail" class="video-thumbnail" />
        <div class="tutorial-text">
          <h5>Video 1 - Basics and Map Creation video</h5>
          <a href="https://www.youtube.com/watch?v=6MFiHXAVUUY" target="_blank" class="tutorial-link">
            Azgaar's Fantasy Map Generator Tutorial Part 1: Basics and Creating your own map
          </a>
        </div>
      </div>

      <!-- Video 2 -->
      <div class="tutorial-item">
        <img src="https://img.youtube.com/vi/Hps8JTHmfJc/mqdefault.jpg" alt="Video 2 Thumbnail" class="video-thumbnail" />
        <div class="tutorial-text">
          <h5>Video 2 - Heightmap, Biomes, & Rivers</h5>
          <a href="https://www.youtube.com/watch?v=Hps8JTHmfJc" target="_blank" class="tutorial-link">
            Azgaar's Fantasy Map Generator Tutorial Part 2: Heightmap, Biomes, & Rivers in detail
          </a>
        </div>
      </div>

      <!-- Video 3 -->
      <div class="tutorial-item">
        <img src="https://img.youtube.com/vi/GTS5btOwOwk/mqdefault.jpg" alt="Video 3 Thumbnail" class="video-thumbnail" />
        <div class="tutorial-text">
          <h5>Video 3 - Cultures, States, Cities, Provinces, Diplomacy</h5>
          <a href="https://www.youtube.com/watch?v=GTS5btOwOwk" target="_blank" class="tutorial-link">
            Azgaar's Fantasy Map Generator Tutorial Part 3: Political mapping, military, and more
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="btn-sec">
    <button class="btn btn-theme" (click)="close()">OK</button>
  </div>
</div>
 